function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useGiveawayStore from '@/stores/GiveawayStore';
import { useShallow } from 'zustand/react/shallow';
import { CheckIcon, Radio, Text } from '@mantine/core';
import styles from './GiveawayTypeStep.module.scss';
import { GiveawayType } from '@/types/client';
import Icon, { IconSizes } from '../Icon';
import { faMessage } from '@fortawesome/free-solid-svg-icons';
import { faMessageText } from '../icons/fontawesome/MessageText';
import { faMessageQuestion } from '../icons/fontawesome/MessageQuestion';
import GiveawayCreateFooter from './GiveawayCreateFooter';
function RadioCard(_param) {
    var title = _param.title, description = _param.description, icon = _param.icon, props = _object_without_properties(_param, [
        "title",
        "description",
        "icon"
    ]);
    return /*#__PURE__*/ _jsxs(Radio.Card, _object_spread_props(_object_spread({
        className: styles.root,
        radius: "md"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.iconContainer,
                children: /*#__PURE__*/ _jsx(Icon, {
                    className: styles.icon,
                    icon: icon,
                    size: IconSizes.MD
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        size: "sm",
                        className: styles.description,
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Radio.Indicator, {
                icon: CheckIcon,
                className: styles.indicator
            })
        ]
    }), title);
}
function GiveawayTypeStep(param) {
    var onNext = param.onNext;
    var intl = useIntl();
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            type: state.type,
            setType: state.setType
        };
    })), setType = _useGiveawayStore.setType, type = _useGiveawayStore.type;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: styles.subHeading,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "R8PIbj",
                    defaultMessage: "Select the type of giveaway you want to create."
                })
            }),
            /*#__PURE__*/ _jsx(Radio.Group, {
                value: type,
                onChange: function(value) {
                    return setType(value);
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.radioGroupInner,
                    children: [
                        /*#__PURE__*/ _jsx(RadioCard, {
                            icon: faMessage,
                            value: GiveawayType.ACTIVE_USER,
                            title: intl.formatMessage({
                                id: "oM9CgE",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Active Chatters"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "wL7WJI",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Giveaway to active chatters in chat."
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(RadioCard, {
                            icon: faMessageText,
                            value: GiveawayType.KEYWORD,
                            title: intl.formatMessage({
                                id: "fe0rMF",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Keyword"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "ebOM6V",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Giveaway to chatters who type a keyword."
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(RadioCard, {
                            icon: faMessageQuestion,
                            value: GiveawayType.RANDOM_NUMBER,
                            title: intl.formatMessage({
                                id: "FXn2yf",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Random Number"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "+fMSKR",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Giveaway to chatters who guess a number."
                                    }
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(GiveawayCreateFooter, {
                backButtonProps: {
                    disabled: true
                },
                nextButtonProps: {
                    onClick: onNext
                },
                nextText: intl.formatMessage({
                    id: "9+Ddtu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Next"
                        }
                    ]
                })
            })
        ]
    });
}
export default GiveawayTypeStep;
